module.exports = __webpack_public_path__ + "static/media/editActivityOpt1.574d2d72.png";